'use strict';

import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { ordersOperations, ordersSelectors } from '@/state/domains/orders';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { locationsSelectors } from '@/state/domains/locations';

//import s from './styles.scss';
import m from '../styles.scss';

export default connect(
	(state, props) => ({
		modals: appSelectors.getModalStates(state, props),
		modalProps: appSelectors.getModalProps(state, props),
		job: ordersSelectors.getPageJob(state, props),
		location: locationsSelectors.getPageLocation(state, props),
		serveAttempt: attemptsSelectors.getServeAttempt(state, props),
		postAttempt: attemptsSelectors.getPostAttempt(state, props),
		badAddressAttempt: attemptsSelectors.getBadAddressAttempt(state, props),
		pickupAttempt: attemptsSelectors.getPickupAttempt(state, props),
		deliveryAttempt: attemptsSelectors.getDeliveryAttempt(state, props),
	}),
	{
		setModalClose: appOperations.setModalClose,
		postUncompleteTask: ordersOperations.postUncompleteTask,
	}
)(
	({
		job,
		location,
		modals,
		modalProps,
		setModalClose,
		postUncompleteTask,
		serveAttempt,
		postAttempt,
		badAddressAttempt,
		pickupAttempt,
		deliveryAttempt,
	}) => {

		const { id, type, username, date } = modalProps;

		const ctxs = {
			serve: {
				type: 'SERVE',
				title: 'Undo Serve',
				isOpen: modals.undoServe,
				attempt: serveAttempt,
			},
			post: {
				type: 'POST',
				title: 'Undo Post',
				isOpen: modals.undoPost,
				attempt: postAttempt,
			},
			badAddress: {
				type: 'BAD_ADDRESS',
				title: 'Undo Bad Address',
				isOpen: modals.undoBadAddress,
				attempt: badAddressAttempt,
			},
			pickup: {
				type: 'PICKUP',
				title: 'Undo Pickup',
				isOpen: modals.undoPickup,
				attempt: pickupAttempt,
			},
			delivery: {
				type: 'DELIVERY',
				title: 'Undo Delivery',
				isOpen: modals.undoDelivery,
				attempt: deliveryAttempt,
			},
		};

		if (!type || !(type in ctxs)) {
			return <div />;
		}

		const ctx = ctxs[ type ];

		const undo = () => {

			postUncompleteTask(
				username,
				date,
				job._id,
				location._id,
				ctx.type,
				ctx.attempt._id
			);

			setModalClose(id);
		};

		return (
			<Modal
				appElement={ document.getElementById('root') }
				overlayClassName={ m.modalOverlay }
				isOpen={ modals.undoComplete }
				contentLabel='Confirm Undo'
				shouldCloseOnOverlayClick={ true }
				shouldCloseOnEsc={ true }
				onRequestClose={ () => setModalClose('undoComplete') }
				className={ m.modal }
			>
				<p>{ ctx.title }</p>
				<div className={ m.btns }>
					<button
						onClick={ () => setModalClose('undoComplete') }
						className={ m.cancel }
					>
						Cancel
					</button>
					<button
						onClick={ undo }
						className={ m.proceed }
					>
						Proceed
					</button>
				</div>
			</Modal>
		);
	}
);
